import React from "react";

import Display from "../../util/Display";

class LeadScore extends React.Component {
  render() {
    if(this.props.isEnterprise) {
      const score = Display.FieldValue(this.props.lead, "lead_score", this.props.fields);
      return (
        <p style={{ fontSize: "18px", fontWeight: "bold" , textAlign: "center"}}> Lead Score
          <span style={{
            fontSize: "35px",
            textAlign: "center",
            border: "1px solid",
            backgroundColor: "#95bbdf",
            borderRadius: "50%",
            padding: "5px 15px",
            margin: "0 auto",
            display: "block"
          }}>
            { score ? score : "-" }
          </span>
        </p>
      );
    }

    return (
      <img src={process.env.PUBLIC_URL + "/images/user.png"} alt="user" className="img-fluid"/>
    );
  }
}
export default LeadScore;
